import React, { useEffect, useState } from 'react';
import { ChevronUpIcon } from '@heroicons/react/24/outline';
import { useLanguage } from '../LanguageContext';

const GoToTop: React.FC = () => {
  const { language } = useLanguage();
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setIsVisible(window.scrollY > 320);

    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });

    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  if (!isVisible) {
    return null;
  }

  return (
    <button
      type="button"
      onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
      className="fixed bottom-6 right-6 z-[60] inline-flex h-12 w-12 items-center justify-center rounded-full bg-[var(--color-forest)] text-white shadow-[0_16px_40px_rgba(27,94,32,0.24)] transition hover:-translate-y-1 hover:bg-[#174f1b]"
      aria-label={language === 'hi' ? 'ऊपर जाएँ' : 'Go to top'}
    >
      <ChevronUpIcon className="h-5 w-5" />
    </button>
  );
};

export default GoToTop;
